import type { ApiErrorRequest } from './@types'

class ApiError<ErrorBody> extends Error {
  request?: ApiErrorRequest
  response?: Response
  responseBody?: ErrorBody

  constructor(
    message: string,
    request?: ApiErrorRequest,
    response?: Response,
    responseBody?: ErrorBody,
  ) {
    super(message)
    this.request = request
    this.response = response
    this.responseBody = responseBody
  }
}

export class NotFoundApiError<ErrorBody> extends ApiError<ErrorBody> {
  constructor(request: ApiErrorRequest, response: Response, body: ErrorBody) {
    super('NotFound', request, response, body)
  }
}
export class BadRequestApiError<ErrorBody> extends ApiError<ErrorBody> {
  constructor(request: ApiErrorRequest, response: Response, body: ErrorBody) {
    super('BadRequest', request, response, body)
  }
}
export class UnauthorizedApiError<ErrorBody> extends ApiError<ErrorBody> {
  constructor(request: ApiErrorRequest, response: Response, body: ErrorBody) {
    super('Unauthorized', request, response, body)
  }
}
export class InternalServerApiError<ErrorBody> extends ApiError<ErrorBody> {
  constructor(request: ApiErrorRequest, response: Response, body: ErrorBody) {
    super('InternalServerError', request, response, body)
  }
}
export class UnknownApiError<ErrorBody> extends ApiError<ErrorBody> {
  constructor(request: ApiErrorRequest, response: Response, body: ErrorBody) {
    super('Unknown', request, response, body)
  }
}

export class ApiFetchError extends ApiError<undefined> {
  constructor(error: unknown, request: ApiErrorRequest) {
    super(error instanceof Error ? error.message : 'UnknownFetchError', request)
  }
}

export class ApiResponseParseError<ErrorBody> extends ApiError<ErrorBody> {
  constructor(error: unknown, request: ApiErrorRequest, response: Response) {
    super(error instanceof Error ? error.message : 'ParseResponseError', request, response)
  }
}

export default ApiError
